import { useQueryClient, useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createTestimonial } from "./endpoints";

export const useCreateTestimonial = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTestimonial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["testimonials"] });
      queryClient.refetchQueries({ queryKey: ["testimonials"] });
      toast.info("Testimonial was created!");
    },
    onError: (error) => {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("An unexpected error occured!, Please try again");
      }
    },
  });
};
